import { styled } from '@mui/material';

export const GridContainer = styled('div')(({ theme }) => ({
  marginTop: 'var(--spacer-xl)',
  display: 'grid',
  gap: 'var(--gutter)',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: 'repeat(min-content, 1fr)',

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(5, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(5, 1fr)',
  },
}));
